import React from "react";
import { Col, Row } from "react-bootstrap";

const LineItemContainer = ({ lineItem }) => {
  return (
    <div className="line_item_container">
      <Row>
        <Col sm={3}>
          <img
            src={`${process.env.REACT_APP_API_URL}${lineItem?.image.src ?? ""}`}
            alt={"product_image"}
          />
        </Col>
        <Col sm={9}>
          <p>{lineItem?.product?.name ?? ""}</p>
          <p>Each : Ksh {lineItem.price}</p>
          <p>Quantity : {lineItem?.quantity}</p>
          <p>Tax : {lineItem?.total_tax}</p>
          <p>Total : {lineItem?.total}</p>
        </Col>
      </Row>
    </div>
  );
};

export default LineItemContainer;
